/*LIBRARY*/
import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useParams, useHistory } from "react-router-dom";

/*COMPONENT*/
import Register from "../../Components/auth/Register";
import NavigationLanding from "../../Components/layout/NavigationLanding";
import LandingAuth from "../../Components/layout/LandingAuth";

/*REDUX*/

/*PICTURE*/

/*FUNCTION*/

/*DATA*/
import dict from "../../Data/dict.json";
import domain_list from "../../Data/domain_list";

/*CONST*/

const LandingRegister = () => {
  const [width, setWidth] = useState(window.innerWidth);
  const [registration_step, setRegistrationStep] = useState({
    step: 1,
    page: 1,
  });

  const { auth } = useSelector((state) => state);
  const { kode } = useParams();
  const history = useHistory();

  useEffect(() => {
    const token_mapid = localStorage.getItem("token_mapid");
    const mapid_user = localStorage.getItem("mapid_user");

    if (token_mapid && mapid_user) {
      history.push("/dashboard");
    }
  }, [history]);

  useEffect(() => {
    const handleWindowSizeChange = () => {
      setWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleWindowSizeChange);

    return () => {
      window.removeEventListener("resize", handleWindowSizeChange);
    };
  }, []);

  const set_registration_step = ({ step, page }) => {
    setRegistrationStep((prev) => {
      const old_step = prev?.step;
      const old_page = prev?.page;
      return {
        step: step === undefined || step === null ? old_step : step,
        page: page === undefined || page === null ? old_page : page,
      };
    });
  };

  const handle_login_button = () => {
    const params = new URLSearchParams(window.location.search);
    const params_str = params.toString();
    if (params_str) {
      history.push(`/login?${params_str}`);
    } else {
      history.push(`/login`);
    }
  };

  const language = localStorage?.language ? localStorage?.language : "ina";
  const domain = auth.domain;
  const { step } = registration_step;
  const horizontal_line_width = width > 800 ? "w_30" : "w_5";

  // multi_steps_progress
  const registration_step_progress = (
    <main className="flex gap_10 align_center">
      {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */}
      <div
        onClick={() => set_registration_step({ step: 1, page: 1 })}
        className={`step_progress ${step === 1 ? "active" : ""}`}
      >
        1
      </div>
      <hr className={`horizontal_line ${horizontal_line_width}`} />
      {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */}
      <div
        onClick={() => set_registration_step({ step: 2, page: 1 })}
        className={`step_progress ${step === 2 ? "active" : ""}`}
      >
        2
      </div>
      <hr className={`horizontal_line ${horizontal_line_width}`} />
      {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */}
      <div
        onClick={() => set_registration_step({ step: 3, page: 1 })}
        className={`step_progress ${step === 3 || step === 4 ? "active" : ""}`}
      >
        3
      </div>
    </main>
  );

  let title = "";
  let desc = "";
  if (step === 1) {
    title = dict["Create a New Organization"][language];
    desc =
      dict[
        "Create an organization to bring teams together and easily manage projects in one place."
      ][language];
  } else if (step === 2) {
    title = dict["Personalizing Your Organization"][language];
    desc =
      dict[
        "We will tailor our demos and examples so they're relevant for your industry and use case."
      ][language];
  } else if (step === 3) {
    title = dict["Tell Us About Yourself"][language];
    desc =
      dict["Complete your profile before creating the organization."][language];
  }

  const itemContent = (
    <div className={`box_content`}>
      <h1> {title}</h1>
      <p>{desc}</p>
      <Register
        set_registration_step={set_registration_step}
        registration_step={registration_step}
        kode={kode}
      />
      <div className="box_content_bottom">
        <p className="button_account">
          {dict["Already have an account?"][language]}
        </p>
        <button
          onClick={handle_login_button}
          className="button_register text_black bold"
        >
          {dict["Login instead"][language]}
        </button>
      </div>
    </div>
  );

  return (
    <>
      <LandingAuth
        nav={<NavigationLanding />}
        title={domain_list?.[domain]?.title}
        subtitle={domain_list?.[domain]?.sub_title}
        content={itemContent}
        registration_step_progress={registration_step_progress}
        from="register"
      />
    </>
  );
};

export default LandingRegister;
